// the below are required at the application entrypoint
import 'babel-polyfill';
import './chunks-bootstrap';
import ReactDOM from 'react-dom';
import React, { Component } from 'react';

const GlobalStyle = React.lazy(() => import('@/integrations/styling'));
const EntrypointModal = React.lazy(
  () => import('@/containers/EntrypointModal'),
);
const UserActionsHandler = React.lazy(
  () => import('@/containers/UserActionsHandler'),
);
const TrevorIntercomProvider = React.lazy(
  () => import('@/integrations/Intercom/TrevorIntercomProvider'),
);
const StoreProvider = React.lazy(() => import('@/store/StoreProvider'));
const TrevorRouterProvider = React.lazy(
  () => import('@/routing/TrevorRouterProvider'),
);
const GlobalErrorNotification = React.lazy(
  () => import('@/integrations/Notifications/GlobalErrorNotification'),
);
const TrevorNotificationContainer = React.lazy(
  () => import('@/integrations/Notifications/TrevorNotificationContainer'),
);

const trevorRoot = document.getElementById('root') as HTMLElement;

class NoOpErrorBoundary extends Component {
  //
  // https://reactjs.org/blog/2017/07/26/error-handling-in-react-16.html
  //
  componentDidCatch() {
    // no-op.
    // Presence of this hook is enough to prevent exception from bubbling further up
    // which means that NotificationContainer will still be rendered
    // and error catch-all above will log out this error to the console for us
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

ReactDOM.render(
  <NoOpErrorBoundary>
    <React.Suspense fallback={<div />}>
      <GlobalErrorNotification />
      <GlobalStyle />
      {/* NOTE: this currently relies on you importing /css/react-notifications.css in .html file */}
      <TrevorNotificationContainer />

      <TrevorIntercomProvider>
        <StoreProvider>
          <UserActionsHandler />
          <TrevorRouterProvider />
          <EntrypointModal />
        </StoreProvider>
      </TrevorIntercomProvider>
    </React.Suspense>
  </NoOpErrorBoundary>,
  trevorRoot,
);
